import { render, staticRenderFns } from "./MlocalidadForm.vue?vue&type=template&id=a6e5f49e"
import script from "./MlocalidadForm.vue?vue&type=script&lang=js"
export * from "./MlocalidadForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports